<template>
  <modal-campaign-targeting-rule @save="save" @close="close">
    <div class="d-flex align-items-center">
      <span class="mr-2">Visitors who have spent a minimum of</span>
      <input class="form-control form-control-sm text-center" style="width: 6rem" type="number" v-model="timeSpentOnPageData" />
      <span class="ml-2"> seconds on the current subpage. </span>
    </div>
  </modal-campaign-targeting-rule>
</template>

<script>
import ModalCampaignTargetingRule from "@/components/modals/ModalCampaignTargetingRule"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"
import targetingRuleModalMixin from "@/components/campaign-targeting-rules/modals/targeting-rule-modal-mixin"

const mixin = targetingRuleModalMixin("who", targetingRuleNames.whoRules.timeSpentOnPage)

export default {
  name: "TimeSpentOnPageModal",
  components: { ModalCampaignTargetingRule },
  mixins: [mixin],
  computed: {
    timeSpentOnPageData: {
      get: function () {
        return this.value / 1000
      },
      set: function (value) {
        this.value = value * 1000
      }
    }
  }
}
</script>
